import styles from './Eyebrow.module.css';

export function Eyebrow({ children, dark = false }) {
  return <span className={`${styles.eyebrow} ${dark ? styles.dark : ''}`}>{children}</span>;
}
